import { createRouter as createTanstackRouter } from '@tanstack/react-router';
import { routeTree } from '../../routeTree.gen';
import { getQueryClient } from '../query-client/query-client.singleton';

function createRouter() {
  return createTanstackRouter({
    routeTree,
    context: {
      queryClient: getQueryClient(),
    },
  });
}

let _router: ReturnType<typeof createRouter> | null = null;

export function getRouter() {
  if (!_router) {
    _router = createRouter();
  }

  return _router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
